import { Database } from "../../constants/schema.js";
//#region src/utils/schema-dbml-parser/dataType.ts
var stringTypes = {
	[Database.MariaDB]: "VARCHAR(255)",
	[Database.MSSQL]: "varchar(255)",
	[Database.MySQL]: "VARCHAR(255)",
	[Database.Oracle]: "VARCHAR2(255)",
	[Database.PostgreSQL]: "varchar(255)",
	[Database.SQLite]: "TEXT",
	[Database.Databricks]: "STRING",
	[Database.Snowflake]: "VARCHAR(255)"
};
function resolveDataType(typeName, typeSchemaName, database, model) {
	const members = getMembers(typeName, typeSchemaName, model);
	if (!members) return typeName;
	return enumDataType(members, database) ?? stringTypes[database] ?? typeName;
}
function enumCommentSuffix(typeName, typeSchemaName, model, database) {
	const members = getMembers(typeName, typeSchemaName, model);
	if (!members || enumDataType(members, database) !== void 0) return "";
	return ` ${typeName}: ${members.join(" | ")}`;
}
function enumDataType(members, database) {
	if (database !== Database.MySQL && database !== Database.MariaDB) return;
	return `ENUM(${members.map((member) => `'${member.replace(/'/g, "''")}'`).join(",")})`;
}
function getMembers(typeName, typeSchemaName, model) {
	const qualified = typeSchemaName ? `${typeSchemaName}.${typeName}` : "";
	return model.enums[qualified] ?? model.enums[typeName] ?? null;
}
//#endregion
export { enumCommentSuffix, resolveDataType };
